import {
  RetryFailedNotifications,
  RetryFailedNotificationsVariables
} from './__generated__/RetryFailedNotifications'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation RetryFailedNotifications($scheduledId: String!) {
    retryFailedNotificationsV2(scheduledId: $scheduledId) {
      alreadyDelivered
      retried
      totalIntended
    }
  }
`

export const useRetryFailedNotifications = () =>
  useMutation<RetryFailedNotifications, RetryFailedNotificationsVariables>(MUTATION)
